export const QueryKeys = Object.freeze({
  myEnvironments: 'myEnvironments',
  billingSubscription: 'billingSubscription',
  bridgeHealthCheck: 'bridgeHealthCheck',
  fetchWorkflow: 'fetchWorkflow',
  fetchWorkflowTestData: 'fetchWorkflowTestData',
  fetchWorkflows: 'fetchWorkflows',
  fetchTags: 'fetchTags',
  getApiKeys: 'getApiKeys',
  dashboardInboxHashes: 'dashboardInboxHashes',
  agentWebChatHash: 'agentWebChatHash',
  fetchIntegrations: 'fetchIntegrations',
  fetchActivity: 'fetchActivity',
  fetchActivities: 'fetchActivities',
  fetchWorkflowRunsCount: 'fetchWorkflowRunsCount',
  fetchConversationUsage: 'fetchConversationUsage',
  fetchSubscribers: 'fetchSubscribers',
  fetchSubscriber: 'fetchSubscriber',
  fetchSubscriberPreferences: 'fetchSubscriberPreferences',
  patchSubscriberPreferences: 'patchSubscriberPreferences',
  fetchTopics: 'fetchTopics',
  fetchRequestLogs: 'fetchRequestLogs',
  myOrganization: 'myOrganization',
  organizationSettings: 'organizationSettings',
  fetchLayouts: 'fetchLayouts',
  fetchLayout: 'fetchLayout',
  fetchLayoutUsage: 'fetchLayoutUsage',
  fetchAgentUsage: 'fetchAgentUsage',
  previewLayout: 'previewLayout',
  fetchTranslations: 'fetchTranslations',
  fetchTranslationGroups: 'fetchTranslationGroups',
  fetchTranslationGroup: 'fetchTranslationGroup',
  fetchTranslation: 'fetchTranslation',
  fetchTranslationKeys: 'fetchTranslationKeys',
  diffEnvironments: 'diff-environments',
  previewStep: 'preview-step',
  fetchCharts: 'fetchCharts',
  fetchContexts: 'fetchContexts',
  fetchContext: 'fetchContext',
  fetchSubscriberSubscriptions: 'fetchSubscriberSubscriptions',
  fetchChannelEndpoints: 'fetchChannelEndpoints',
  fetchChannelConnections: 'fetchChannelConnections',
  fetchChat: 'fetchChat',
  fetchEnvironmentVariables: 'fetchEnvironmentVariables',
  fetchEnvironmentVariable: 'fetchEnvironmentVariable',
  fetchEnvironmentVariableUsage: 'fetchEnvironmentVariableUsage',
  stepResolversCount: 'stepResolversCount',
  fetchWorkflowSuggestions: 'fetchWorkflowSuggestions',
  fetchDomains: 'fetchDomains',
  fetchDomain: 'fetchDomain',
  fetchDomainRoutes: 'fetchDomainRoutes',
  fetchDomainConnectStatus: 'fetchDomainConnectStatus',
  localBridgeHealth: 'localBridgeHealth',
  localDiscover: 'localDiscover',
});
